module.exports = __webpack_public_path__ + "static/media/MbBanescoContigoLogo.867278b8.svg";